<template>
  <div class="recharge-detail-dialog">
    <el-dialog
      :title="$t('orderList.orderList146')"
      :visible="visible"
      :close-on-click-modal="false"
      width="70%"
      top="4vh"
      custom-class="lx-dialog recharge-invoice-dialog"
      @close="close"
    >
      <el-scrollbar class="invoice-scroll">
        <div class="invoice-sheet" v-loading="loading">
          <div class="invoice-title">{{ $t('recharge.rechargeDetail1') }}</div>

          <el-row class="top-block" :gutter="24">
            <el-col :span="13">
              <div class="customer-line">
                <span class="ellipsis">{{ invoice.realName || '-' }}</span>
                <span>様</span>
              </div>
              <div class="subject-line"><b>{{ $t('saledFeedback.addTemplate03') }}：</b><b>{{ $t('recharge.rechargeDetail5') }}</b></div>
              <div class="request-text">{{ $t('recharge.rechargeDetail10') }}</div>
            </el-col>
            <el-col :span="11">
              <div class="issuer-box">
                <div v-for="(item, index) in issuerLines" :key="index" :class="item.className">{{ item.text }}</div>
              </div>
            </el-col>
          </el-row>

          <div class="amount-rate-row">
            <div class="total-amount"><b>{{ $t('fba.totalAmount1') }}</b><b class="total-value">¥{{ money(totalJpy) }}</b></div>
            <div class="rate-box">
                <span>{{ $t('recharge.rechargeDetail8') }}</span>
                <span>{{ invoice.exchangeRate || '-' }}</span>
            </div>
          </div>

          <el-table
            class="detail-table"
            :data="detailRows"
            border
            show-summary
            :summary-method="detailSummary"
          >
            <el-table-column v-for="column in columns" :key="column.prop" v-bind="column" />
          </el-table>

          <el-table
            class="detail-table tax-table"
            :data="taxRows"
            border
            show-summary
            :summary-method="taxSummary"
            :show-header="false"
            :span-method="taxSpanMethod"
          >
            <el-table-column prop="no" width="40" align="center"></el-table-column>
            <el-table-column prop="label" min-width="330"></el-table-column>
            <el-table-column prop="middle" width="40" align="center"></el-table-column>
            <el-table-column prop="blank" width="66"></el-table-column>
            <el-table-column prop="cny" width="94"></el-table-column>
            <el-table-column prop="amount" width="120" align="right"></el-table-column>
          </el-table>

          <div class="bank-box">
            <div v-for="(line, index) in bankLines" :key="index">{{ line }}</div>
          </div>

          <div class="note-box">
            <div class="note-label">{{ $t('dict.remark') }}</div>
            <div class="note-content">{{ $t('recharge.rechargeDetail9') }}</div>
          </div>
        </div>
      </el-scrollbar>
      <span slot="footer"><el-button class="btn btn-secondary" @click="close">{{ $t('saledFeedback.fanhui') }}</el-button></span>
    </el-dialog>
  </div>
</template>

<script>

const fieldMap = {
  realName: ['realName', 'drawee', 'payUser'],
  rechargeNo: ['rechargeNo', 'tradingNo', 'orderNum'],
  payTime: ['payTime', 'createTime'],
  tenantName: ['tenantName', 'companyName'],
  contactPhone: ['contactPhone', 'phone'],
  contactEmail: ['contactEmail', 'email'],
  accountNumber: ['accountNumber', 'bankNo'],
  address: ['address'],
  exchangeRate: ['exchangeRate'],
  tradingNo: ['tradingNo'],
  money: ['money'],
  moneyJpy: ['moneyJpy'],
  bankName: ['bankName'],
  branchName: ['branchName'],
  accountType: ['accountType'],
  accountHolder: ['accountHolder']
}

export default {
  name: 'RechargeDetail',
  props: {
    visible: Boolean,
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      detailData: {},
      loading: false
    }
  },
  computed: {
    columns() {
      return [
        { prop: 'no', label: 'No.', width: 40, align: 'center' },
        { prop: 'desc', label: '摘要', minWidth: 330 },
        { prop: 'qty', label: this.$t('defe.defe71'), width: 40, align: 'center' },
        { prop: 'price', label: this.$t('OrderBill.OrderBill4'), width: 66, align: 'right' },
        { prop: 'cny', label: `${this.$t('fba.amount')}(元)`, width: 94, align: 'right' },
        { prop: 'jpy', label: `${this.$t('fba.amount')}(円)`, width: 120, align: 'right' }
      ]
    },
    invoice() {
      return Object.keys(fieldMap).reduce((data, key) => {
        data[key] = this.pick(fieldMap[key])
        return data
      }, {})
    },
    issuerLines() {
      const item = (text, className = '') => ({ text, className })
      return [
        item(`${this.$t('recharge.rechargeDetail2')}.${this.invoice.rechargeNo || '-'}`),
        item(`${this.$t('recharge.rechargeDetail3')}:${this.formatDate(this.invoice.payTime)}`),
        item(this.invoice.tenantName || '-', 'mt-lg'),
        item(`Tel：${this.invoice.contactPhone || '-'}`),
        item(this.invoice.address || '-'),
        item(`E-Mail：${this.invoice.contactEmail || '-'}`),
        item(`${this.$t('recharge.rechargeDetail4')}：T3130001076016`, 'mt-xl')
      ]
    },
    detailRows() {
      return [
        {
          no: 1,
          desc: `${this.$t('recharge.rechargeDetail5')}(${this.$t('recharge.tradeNo')}：${this.invoice.tradingNo || '-'})`,
          qty: '1',
          price: this.money(this.invoice.money),
          cny: this.money(this.invoice.money),
          jpy: this.money(this.invoice.moneyJpy)
        },
        ...Array.from({ length: 2 }, (_, i) => ({ no: i + 2, desc: '', qty: '', price: '', cny: '0.00', jpy: '0' }))
      ]
    },
    totalJpy() {
      return this.num(this.invoice.moneyJpy)
    },
    taxableAmount() {
      return Math.floor(this.totalJpy * 0.01)
    },
    consumptionTax() {
      return Math.floor(this.taxableAmount * 0.1)
    },
    taxFreeAmount() {
      return this.totalJpy - this.taxableAmount - this.consumptionTax
    },
    taxRows() {
      return [
        ['', `${this.$t('recharge.rechargeDetail6')}`, '', '', this.taxFreeAmount],
        ['', `${this.$t('recharge.rechargeDetail11')}`, '', '', this.taxableAmount],
        ['', `${this.$t('recharge.rechargeDetail7')}`, '', '', this.consumptionTax]
      ].map(([no, label, middle, blank, value]) => ({
        no,
        label,
        middle,
        blank,
        amount: `¥${this.money(value)}`
      }))
    },
    bankLines() {
      const i = this.invoice
      return [`${this.$t('recharge.rechargeDetail12')}`, `${i.bankName || '-'}　${i.branchName || '-'}（${i.accountType || '-'}）`, `${this.$t('recharge.rechargeDetail13')}　${i.accountNumber || '-'}`, i.accountHolder || '-']
    }
  },
  watch: {
    visible(value) {
      if (value) this.fetchDetail()
    },
    'row.id'(value, oldValue) {
      if (this.visible && value !== oldValue) this.fetchDetail()
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async fetchDetail() {
      const id = this.row && this.row.id
      if (!id) {
        this.detailData = {}
        return
      }
      this.loading = true
      this.detailData = {}
      try {
        const { data: res } = await this.$http.post('payRecord/pdfData', { id })
        this.detailData = res && res.data ? res.data : (res || {})
      } catch (error) {
        console.log(error)
        this.detailData = {}
      } finally {
        this.loading = false
      }
    },
    pick(keys) {
      const source = { ...this.row, ...this.detailData }
      const key = keys.find(name => source[name] || source[name] === 0)
      return key ? source[key] : ''
    },
    detailSummary() {
      return ['', '', '小計', '', '', this.money(this.invoice.moneyJpy)]
    },
    taxSummary() {
      return ['', '', '合计', '', '', `¥${this.money(this.totalJpy)}`]
    },
    taxSpanMethod({ row, columnIndex }) {
      if (columnIndex === 1) return [1, 3]
      if ([2, 3].includes(columnIndex)) return [0, 0]
      return [1, 1]
    },
    num(value) {
      const num = Number(`${value || 0}`.replace(/,/g, ''))
      return Number.isFinite(num) ? num : 0
    },
    money(value) {
      return this.num(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    formatDate(value) {
      if (!value) return '-'
      const timestamp = `${value}`.length === 10 ? Number(value) * 1000 : Number(value)
      const date = Number.isFinite(timestamp) ? new Date(timestamp) : new Date(value)
      if (Number.isNaN(date.getTime())) return value
      const pad = num => `${num}`.padStart(2, '0')
      return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())}`
    }
  }
}
</script>

<style lang="less" scoped>
.invoice-scroll { height: 720px; }
.invoice-sheet {
  width: 100%;
  margin: 0 auto;
  padding: 22px 28px 16px;
  background: var(--bg-card);
  color: var(--text-main);
  font: 14px/1.35 Arial, "Microsoft YaHei", sans-serif;
}
.invoice-title { margin-bottom: 16px; text-align: center; font-size: 24px; font-weight: 700; }
.top-block { min-height: 190px; }

.customer-line,
.amount-rate-row,
.total-amount,
.rate-box,
.note-box { display: grid; }

.customer-line {
  grid-template-columns: 1fr 48px;
  width: 220px;
  margin-top: 4px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--border);
  text-align: center;
  font-size: 18px;
  font-weight: 700;
}
.ellipsis { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.subject-line { width: 336px; margin-top: 34px; padding: 0 0 5px 31px; border-bottom: 1px solid var(--border); font-size: 12px; }
.request-text { width: 336px; padding-left: 31px; font-size: 12px; }
.issuer-box { padding-left: 46px; line-height: 1.55; }
.mt-lg { margin-top: 22px; }
.mt-xl { margin-top: 28px; }

.amount-rate-row { grid-template-columns: 1fr 230px; align-items: end; margin-bottom: 6px; margin-top: 12px;}
.total-amount { grid-template-columns: 96px 1fr; width: 336px; padding: 0 0 4px 28px; border-bottom: 1px solid var(--border); }
.total-value { font-size: 13px; }
.rate-box { grid-template-columns: 1fr 70px; padding-right: 2px; text-align: center; font-size: 12px; }

.tax-table {
  margin-top: 18px;
}

.bank-box {
  display: inline-block;
  margin: 18px 0 8px 41px;
  line-height: 1.45;
  > div:not(:first-child) { border-bottom: 1px solid var(--border); }
}
.note-box { grid-template-columns: 66px 1fr; min-height: 108px; margin-top: 8px; border: 1px solid var(--border); }
.note-label { display: flex; align-items: center; justify-content: center; background: var(--bg-hover); border-right: 1px solid var(--border); font-weight: 700; }
.note-content { display: flex; align-items: center; padding: 0 28px; }
@media (max-width: 768px) {
  :deep(.recharge-invoice-dialog) {
    min-width: 780px !important;
  }
}
</style>
